import React from 'react';
import RecommendedBadge from './RecommendedBadge';
import './map-option-card.scss';

interface MapOptionCardField {
  label: string;
  value: string;
}

interface MapOptionCardProps {
  id: string;
  imageUrl?: string;
  title: string;
  address?: string;
  highlighted?: boolean;
  highlightedReason?: string;
  fields: MapOptionCardField[];
  onView?: () => void;
  /** Optional slot rendered inside the image area (top-left), used for select ticks */
  tickSlot?: React.ReactNode;
}

const MapOptionCard: React.FC<MapOptionCardProps> = ({
  id,
  imageUrl,
  title,
  address,
  highlighted,
  highlightedReason,
  fields,
  onView,
  tickSlot,
}) => {
  return (
    <div
      className='map-option-card'
      onClick={onView}
      role='button'
      tabIndex={0}
    >
      <div className='card-image'>
        {tickSlot}
        {highlighted && <RecommendedBadge reason={highlightedReason} />}
        {imageUrl && (
          <img src={imageUrl} alt={title} referrerPolicy='no-referrer' />
        )}
      </div>
      <div className='card-mid'>
        <h4>{title}</h4>
        {address && <small>{address}</small>}
      </div>
      {fields.length > 0 && (
        <div className='card-fields'>
          {fields.map((field, idx) => (
            <div key={idx} className='card-field'>
              <span className='field-label'>{field.label}</span>
              <span className='field-value'>{field.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MapOptionCard;
